import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'OrganizationEditUserAttribute.Title',
    defaultMessage: 'Edit User Attribute'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  submitTitle: {
    id: 'Update',
    defaultMessage: 'Update'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  defaultAttributeWarningMessage: {
    id: 'OrganizationEditUserAttribute.DefaultAttributeWarning',
    defaultMessage:
      'This is a default user attribute provided by Workgrid. Some of its characteristics cannot be edited.'
  }
})
